import { Flex, Title } from '@bb/elements-web';
import { Link, Page } from 'components';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { SUPPORT_EMAIL } from 'utils';
import AppointmentBookingInternalContext from './AppointmentBookingInternalContext';

/** Renders error page if listing is inaccessible for some reason, otherwise renders children */
const InaccessibleListingPageWrapper: React.FC = ({ children }) => {
  const { isLoading, listing, canBookAppointment } = useContext(
    AppointmentBookingInternalContext,
  );

  if (isLoading) return <>{children}</>;
  let innerContent = null;

  if (!listing) {
    innerContent = (
      <>
        Listing could not be found. Please contact your brokerage for more
        information.
      </>
    );
  } else if (!listing.org.features.includes('APPOINTMENT')) {
    innerContent = (
      <>
        You do not have permissions to view this page. Please contact
        <Link href={`mailto:${SUPPORT_EMAIL}`}> {SUPPORT_EMAIL}</Link> for more
        information.
      </>
    );
  } else if (listing.visibility === 'pending') {
    innerContent = (
      <>
        Listing is not available for booking appointment. Please contact your
        brokerage for more information.
      </>
    );
  } else if (!canBookAppointment) {
    innerContent = <>You do not have permissions to this listing.</>;
  }

  if (innerContent) {
    return (
      <Page type="filled" fillScreenHeight>
        <StyledFlex justify="center" align="center">
          <Title
            level={3}
            textAlign="center"
            thickness="normal"
            dataCy="appointmentBooking-inaccessibleListing"
          >
            {innerContent}
          </Title>
        </StyledFlex>
      </Page>
    );
  }

  return <>{children}</>;
};

const StyledFlex = styled(Flex)`
  height: 100%;
`;

export default InaccessibleListingPageWrapper;
